import { useQuery } from "@tanstack/react-query";

import { link } from "@/api/client";
import { ago, POLL } from "@/lib/format";

/** Platform outage banner (watchdog findings) — mounted once in the Shell.
 *  Renders nothing when all is well; red strip for crit, amber for warn.
 *  Polls the O(active-alerts) endpoint at DASHBOARD cadence; only mount this
 *  for users holding the Link gate (the endpoint is gate-800). */
export function AlertBanner() {
  const q = useQuery({
    queryKey: ["link", "alerts"],
    queryFn: link.alerts,
    refetchInterval: POLL.DASHBOARD,
    refetchIntervalInBackground: false,
  });
  const alerts = q.data?.alerts ?? [];
  if (alerts.length === 0) return null;

  const worst = alerts.some((a) => a.severity === "crit") ? "crit" : "warn";
  return (
    <div style={{
      padding: "6px 14px", fontSize: 12.5, display: "flex", gap: 14, flexWrap: "wrap",
      background: worst === "crit" ? "rgba(196,57,74,.12)" : "var(--warn-soft)",
      borderBottom: `1px solid ${worst === "crit" ? "rgba(196,57,74,.4)" : "var(--warn-line)"}`,
      color: worst === "crit" ? "#C4394A" : "var(--warn)",
    }}>
      {alerts.map((a) => (
        <span key={a.key} title={`first seen ${new Date(a.first_seen).toLocaleString()}`}>
          {a.severity === "crit" ? "⛔" : "⚠"} {a.message}
          <span style={{ opacity: 0.65 }}> · {ago(a.first_seen)}</span>
        </span>
      ))}
    </div>
  );
}
